import React from 'react';
import { oneOf, string, func } from 'prop-types';
import styled from 'styled-components';
import { styleOverrideReason } from '@ids/core';

/** */
const fontSize = props => {
  switch (props.size) {
    case 'extraSmall':
      return '12px';
    case 'small':
      return '14px';
    case 'medium':
      return '16px';
    default:
      return '14px';
  }
};

/** */
const lineHeight = props => {
  switch (props.size) {
    case 'extraSmall':
      return '16px';
    case 'small':
      return '20px';
    case 'medium':
      return '24px';
    default:
      return '20px';
  }
};

// Link Action Button does not have its own design data so all values will be hard coded until design data are created.
const Button = styled.button`
  border: none;
  background: transparent;
  text-align: right;
  text-decoration: none;
  padding: 0;
  color: #0077c5;
  font: normal 500 ${props => fontSize(props)} Avenir Next forINTUIT, Helvetica,
    Arial, sans-serif;
  line-height: ${props => lineHeight(props)};

  &:hover {
    color: #21abf6;
    text-decoration: underline;
    cursor: pointer;
  }
  &:active {
    color: #21abf6;
    text-decoration: none;
  }
  &:focus {
    color: #21abf6;
    text-decoration: underline;
    outline: none;
  }
`;

/** */
const LinkActionButton = props => {
  const { innerRef, size, children, automationId, ...restProps } = props;

  return (
    <Button
      ref={innerRef}
      data-automation-id={automationId}
      size={size}
      {...restProps}
    >
      {children}
    </Button>
  );
};

LinkActionButton.propTypes = {
  /**
   * Specifies Button size, 'extraSmall', 'small' or 'medium'
   */
  size: oneOf(['extraSmall', 'small', 'medium']),
  /**
   * Label for the link button
   */
  children: string,
  /**
   * Function to return innerRef
   */
  innerRef: func,
  /**
   * ID for automation tests
   */
  automationId: string,
  /**
   * When `style` or `className` prop is provided, provide the reason behind the override.
   */
  styleOverrideReason
};

LinkActionButton.defaultProps = {
  size: 'small',
  children: 'Close',
  innerRef() {},
  automationId: undefined,
  styleOverrideReason: undefined
};

export default LinkActionButton;
